import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainPT() {
  const articleData = {
    title: 'Por que algumas pessoas nos deixam esgotados? (A IA explica)',
    description: 'Sentindo-se emocionalmente esgotado por textos? Saiba como a IA do Toxic Detector detecta comunicação unilateral e padrões sutis de esgotamento emocional em seus relacionamentos.',
    slug: 'emotional-drain-relationships-ai',
    publishDate: '2025-09-03',
    author: 'Editorial Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'O que é esgotamento emocional em relacionamentos?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'O esgotamento emocional acontece quando as interações com alguém deixam você constantemente cansado, frustrado ou culpado, muitas vezes devido à comunicação unilateral ou manipuladora.'
      }
    }, {
      '@type': 'Question',
      name: 'Como as mensagens de texto podem causar esgotamento emocional?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Mensagens unilaterais repetidas, culpa, engajamento inconsistente ou críticas sutis podem deixar você exausto, mesmo sem grandes conflitos.'
      }
    }, {
      '@type': 'Question',
      name: 'A IA pode detectar quem está drenando minha energia emocional?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sim. O Toxic Detector analisa padrões de texto, tom e engajamento para destacar comportamentos unilaterais, manipuladores ou desgastantes instantaneamente.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/pt/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('Link copiado para a área de transferência!');
    }
  };
  return <>
      <MetaTags title="Por que algumas pessoas nos deixam esgotados? — IA explica o esgotamento emocional | ToxicDetector" description="Sentindo-se emocionalmente esgotado por textos? Saiba como a IA do Toxic Detector detecta comunicação unilateral e padrões sutis de esgotamento emocional." keywords="esgotamento emocional em relacionamentos, padrões de texto unilaterais, vampiros de energia, análise emocional IA" canonical={`https://toxicdetector.com/pt/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/dA7JvMmr79gFQy3nZ9PyWw/file_00000000ee5472468a16f1060b3742e2.png" schema={[faqSchema, articleSchema]} data-id="element-8562" data-mp="2wcfi48o580sc" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-8563" data-mp="uggokpf2m793">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-8564" data-mp="phn9wto1sa7c">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-8565" data-mp="13gvb1s3rtse6">
            <div className="flex items-center justify-between" data-id="element-8566" data-mp="13ea80zrql6eu">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-8567" data-mp="ze8cz9gibb8j">
                <span className="text-2xl" data-id="element-8568" data-mp="2ev0iww73umes">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-8569" data-mp="2exv3qou1698q">
                  ToxicDetector
                </span>
              </Link>
              <div className="flex items-center gap-3" data-id="element-8570" data-mp="365y1tgv0lse9">
                <Link to="/signup" className="hidden sm:inline-block bg-red-600 text-white px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-red-700 transition-all shadow-sm hover:shadow-md" data-id="element-8571" data-mp="3a5f5c4qvsfgs">
                  Scan Grátis
                </Link>
                <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Compartilhar artigo" data-id="element-8572" data-mp="3p40tk3ey63fr">
                  <Share2 size={20} className="text-gray-600" data-id="element-8573" data-mp="1r6m3na9111a" />
                </button>
              </div>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-8574" data-mp="bob9trjqt4k7">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-8575" data-mp="bq5ur5v0kwoa">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-8576" data-mp="216htvain25x8" />
            Voltar ao Início
          </Link>

          <header className="mb-16" data-id="element-8577" data-mp="1r6h7tgtdxbpc">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-8578" data-mp="1r7sk650wbrs2">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-8579" data-mp="2jwhijwakhj04">
              <time dateTime={articleData.publishDate} data-id="element-8580" data-mp="2ewv0n9jsnekz">
                {new Date(articleData.publishDate).toLocaleDateString('pt-BR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-8581" data-mp="254z0lsy5dee4">•</span>
              <span data-id="element-8582" data-mp="32nh9v45jb4wk">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-16" data-id="element-8583" data-mp="2xv7cj323b2k9">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ajgMhQjEKnfJfWgPd5sqFq/1763122862210.jpg" alt="IA analisando padrões de esgotamento emocional em mensagens de texto" className="w-full rounded-2xl shadow-lg" data-id="element-8584" data-mp="2xu6290swek3l" />
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200 mb-16" data-id="element-8585" data-mp="m7udmvedxezy">
            <h2 className="font-bold text-xl mb-6 text-gray-900" data-id="element-8586" data-mp="r65p1akbvxka">Índice</h2>
            <ol className="space-y-3.5 text-base list-decimal list-inside" data-id="element-8587" data-mp="d76001swlgnl">
              <li data-id="element-8588" data-mp="h9asuybj2996">
                <a href="#always-something-wrong" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8589" data-mp="h9smroapwbdx">
                  O amigo "Sempre tem algo errado"
                </a>
              </li>
              <li data-id="element-8590" data-mp="8afkbfl0gn2p">
                <a href="#only-when-they-need" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8591" data-mp="1xnsjyri6hmxh">
                  A pessoa que só manda mensagem quando precisa de algo
                </a>
              </li>
              <li data-id="element-8592" data-mp="3i5l8frwnt6td">
                <a href="#dry-texting" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8593" data-mp="3i63ax69x0h9q">
                  O "Dry-Texter" sem emoção
                </a>
              </li>
              <li data-id="element-8594" data-mp="3s2g5s7h75162">
                <a href="#ghost-return" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8595" data-mp="3s1wkqhw91wnt">
                  O artista do Ghost & Return
                </a>
              </li>
              <li data-id="element-8596" data-mp="jmmnpo77vhmw">
                <a href="#guilt-tripper" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8597" data-mp="jn6779cime31">
                  O culpabilizador sutil
                </a>
              </li>
              <li data-id="element-8598" data-mp="2ggr7c3sqp5dh">
                <a href="#faux-supporter" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8599" data-mp="2gh9cxr1akvy2">
                  O falso apoiador
                </a>
              </li>
              <li data-id="element-8600" data-mp="1zk25m7ymezjq">
                <a href="#healthy-toxic-combo" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8601" data-mp="24cven814gu1m">
                  O combo "Saudável-Tóxico"
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-8602" data-mp="1bqiv3l1wwx2e">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-8603" data-mp="1go2dmx5n7w05">
              Você já mandou mensagem para alguém e se sentiu cansado, irritado
              ou estranhamente culpado depois, mesmo que a conversa não tenha
              sido uma briga? Isso é{' '}
              <strong className="text-gray-900" data-id="element-8604" data-mp="2x0heq6b55gjq">
                esgotamento emocional em relacionamentos
              </strong>
              , e é mais comum do que você pensa.
            </p>
            <p className="mb-16 text-lg leading-relaxed text-gray-600" data-id="element-8605" data-mp="pg0sz9u7iwvz">
              Esses são{' '}
              <strong className="text-gray-900" data-id="element-8606" data-mp="lf8hsb1ryhx2">
                padrões de texto unilaterais
              </strong>{' '}
              e manipulação sutil. Nossa{' '}
              <strong className="text-gray-900" data-id="element-8607" data-mp="body9efwxwfb">análise de IA</strong> lê esses
              padrões instantaneamente.
            </p>

            <section id="always-something-wrong" className="mb-16" data-id="element-8608" data-mp="6qcaig7jl8xi">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8609" data-mp="1qg5qer0tdgw">
                1️⃣ O amigo "Sempre tem algo errado"
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8610" data-mp="3tu91agmy8i96">
                Você olha para o seu telefone e sente instantaneamente:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8611" data-mp="1s2vxxw0mqif8">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8612" data-mp="1n2zp9jgzm2tc">
                  "Ai meu Deus... o que agora?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8613" data-mp="3szvw90up6598">
                Cada mensagem é estresse, caos ou reclamações. A IA sinaliza
                isso como uma{' '}
                <strong className="text-gray-900" data-id="element-8614" data-mp="5saflh957mb1">
                  carga emocional unilateral
                </strong>
                .
              </p>
            </section>

            <section id="only-when-they-need" className="mb-16" data-id="element-8615" data-mp="39alkfxy2o4ge">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8616" data-mp="358gtj6z0dlxg">
                2️⃣ A pessoa que só manda mensagem quando precisa de algo
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-8617" data-mp="3j1g9fa2pdi5j">
                <p className="mb-4 text-lg text-gray-700" data-id="element-8618" data-mp="3e6sfuwsudxk3">
                  <strong className="text-gray-900" data-id="element-8619" data-mp="2qi99imtcruun">Nunca:</strong> "Como você
                  está?"
                </p>
                <p className="text-lg text-gray-700" data-id="element-8620" data-mp="2ljoh39kcefgr">
                  <strong className="text-gray-900" data-id="element-8621" data-mp="111ngwklh5wb9">Sempre:</strong> "Você
                  pode...?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8622" data-mp="15ugix0pk6qjn">
                A IA detecta isso como{' '}
                <strong className="text-gray-900" data-id="element-8623" data-mp="s3bpigcsauhr">
                  comunicação transacional
                </strong>
                .
              </p>
            </section>

            <section id="dry-texting" className="mb-16" data-id="element-8624" data-mp="1krhc78neetk8">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8625" data-mp="1orhpur2ob0q8">
                3️⃣ O "Dry-Texter" sem emoção
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8626" data-mp="1argpdcqblvba">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8627" data-mp="1fpryfl8sk1sg">
                  "ok."
                  <br data-id="element-8628" data-mp="3vhfxbm7d84dw" />
                  "K."
                  <br data-id="element-8629" data-mp="4bwkugxjc13c" />
                  "👍"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-8630" data-mp="49tolf5shbq6">
                A IA captura esses{' '}
                <strong className="text-gray-900" data-id="element-8631" data-mp="3cdkqls9t4ap2">sinais de desconexão</strong>{' '}
                instantaneamente.
              </p>
            </section>

            <section id="ghost-return" className="mb-16" data-id="element-8632" data-mp="37lb5qqnju0tn">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8633" data-mp="32oazaemsew20">
                4️⃣ O artista do Ghost & Return
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8634" data-mp="2xpzrsajysxmy">
                Desaparece por 3 semanas. Volta como:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8635" data-mp="2oni2tocxdqw9">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8636" data-mp="2jp6s7bet3ccz">
                  "oiii 😁"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8637" data-mp="mvc2guhg8fxd">
                A IA sinaliza isso como{' '}
                <strong className="text-gray-900" data-id="element-8638" data-mp="hy3katwawbw4">
                  engajamento inconsistente
                </strong>
                .
              </p>
            </section>

            <section id="guilt-tripper" className="mb-16" data-id="element-8639" data-mp="uf4k1cpszon9">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8640" data-mp="z6w8nhpefkar">
                5️⃣ O culpabilizador sutil
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8641" data-mp="144o2widinii4">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8642" data-mp="6j8tii6wdlvi">
                  "Acho que vou sozinho então..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-8643" data-mp="ggeo40epzv0h">
                A IA marca isso como{' '}
                <strong className="text-gray-900" data-id="element-8644" data-mp="kii0cr97r3mt">manipulação passiva</strong>.
              </p>
            </section>

            <section id="faux-supporter" className="mb-16" data-id="element-8645" data-mp="1ruieyxq0h31b">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8646" data-mp="1vx58d32byw0m">
                6️⃣ O falso apoiador
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8647" data-mp="1uh1b0be3kk8n">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8648" data-mp="1phydrd4czib8">
                  "Digo, você tende a reagir exageradamente às vezes."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8649" data-mp="1zejhzw8k0pe0">
                A IA detecta{' '}
                <strong className="text-gray-900" data-id="element-8650" data-mp="2dec9htrwn9n1">crítica mascarada</strong>.
              </p>
            </section>

            <section id="healthy-toxic-combo" className="mb-16" data-id="element-8651" data-mp="28epv3h0cbncn">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8652" data-mp="2n4dw0h4m0jzu">
                7️⃣ O combo "Saudável-Tóxico"
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-8653" data-mp="2i62m66ebe9hm">
                <p className="mb-4 text-lg text-gray-700" data-id="element-8654" data-mp="2w64zrgflagr2">
                  Alguns dias quente. Alguns dias frio.
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-8655" data-mp="3as0xywtniwmp">
                A IA rotula esse padrão como{' '}
                <strong className="text-gray-900" data-id="element-8656" data-mp="3frdkthkiw3pa">
                  ritmo emocional instável
                </strong>
                .
              </p>
            </section>

            <section className="mb-16" data-id="element-8657" data-mp="36qfdapavle1y">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8658" data-mp="36pdz4bykcbg0">
                Por que isso importa
              </h2>
              <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-10 mb-10 border border-red-100" data-id="element-8659" data-mp="2rzq0jihrnqvz">
                <p className="font-bold mb-8 text-2xl text-gray-900" data-id="element-8660" data-mp="2j14l3w7lcrzf">
                  Uma vez que você vê o padrão, você pode:
                </p>
                <ul className="space-y-5" data-id="element-8661" data-mp="2n2zkuw9vixb3">
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-8662" data-mp="292ornml3d6mr">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-8663" data-mp="294rr0x84wc45">
                      ✓
                    </span>
                    <span data-id="element-8664" data-mp="jm32jucf9q84">Proteger sua energia</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-8665" data-mp="euuryuzcvytd">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-8666" data-mp="esqd5hzx5feb">
                      ✓
                    </span>
                    <span data-id="element-8667" data-mp="5uemxh2ysjme">Estabelecer limites</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-8668" data-mp="5sbruimyg0at">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-8669" data-mp="12jmb6wuyx6u0">
                      ✓
                    </span>
                    <span data-id="element-8670" data-mp="tjh4koxlmcgw">Parar de se sentir culpado</span>
                  </li>
                </ul>
              </div>
            </section>

            <section id="faq" className="mb-20" data-id="element-8671" data-mp="ojutal1bz6aq">
              <h2 className="text-4xl font-bold mb-10 tracking-tight text-gray-900" data-id="element-8672" data-mp="3e9ygkh7js41z">
                Perguntas Frequentes
              </h2>
              <div className="space-y-5" data-id="element-8673" data-mp="399u0gsajxbca">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-8674" data-mp="2z89ffedmi2sp" data-mpi={index}>
                    <h3 className="font-bold text-xl mb-4 text-gray-900" data-id="element-8675" data-mp="394cj4oo4i9hr">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-lg" data-id="element-8676" data-mp="3dxxjgnd6vfk4">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl" data-id="element-8677" data-mp="3rvcce22ni5gu">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-8678" data-mp="pkozag9d6xq">
              😮‍💨 Pare de se sentir esgotado.
              <br data-id="element-8679" data-mp="1xjff3shj25dv" />
              Comece a ver com clareza.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-8680" data-mp="22hgzcgqowaqx">
              Pare de adivinhar. Envie seus textos para o Toxic Detector e
              obtenha uma pontuação de toxicidade instantânea.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-10 border border-white/20" data-id="element-8681" data-mp="37wg6r3r8bla">
              <p className="font-bold text-2xl" data-id="element-8682" data-mp="czk3cfta36gy">
                "⚠️ Esgotamento Emocional: Alto. Comunicação unilateral
                detectada."
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-8683" data-mp="3lhg93cgxu71o">
              Escaneie seus chats agora →
            </Link>
          </div>

          <div className="mt-20" data-id="element-8684" data-mp="3qgt4wmpseoge">
            <RelatedBlogPosts posts={[{
            title: 'Por que algumas pessoas nos deixam esgotados? Parte 2',
            description: 'Mais padrões sutis que drenam sua energia, incluindo sobre-explicação e sabe-tudo.',
            slug: 'emotional-drain-part-2',
            emoji: '😭'
          }, {
            title: 'O Guia Definitivo para Textos Passivo-Agressivos',
            description: 'Detecte comportamento passivo-agressivo e manipulação oculta em mensagens de texto.',
            slug: 'ultimate-guide-passive-aggressive-texts',
            emoji: '😤'
          }]} data-id="element-8685" data-mp="19p1j5nlz68wd" />
          </div>

          <div className="mt-16 text-center" data-id="element-8686" data-mp="1m7dma550gre3">
            <button onClick={handleShare} className="inline-flex items-center gap-2 text-gray-700 hover:text-red-600 font-semibold transition-colors px-6 py-3 rounded-lg hover:bg-gray-50" data-id="element-8687" data-mp="1m6c7bpkvjkr3">
              <Share2 size={20} data-id="element-8688" data-mp="2jocbrfrj9oq0" />
              Compartilhar este artigo
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-8689" data-mp="f4ke4i7p91ni">
          <div className="max-w-4xl mx-auto px-6" data-id="element-8690" data-mp="k2ccnv2unm0o">
            <div className="border-t border-gray-800 pt-8 text-center" data-id="element-8691" data-mp="k22omd1d7oxm">
              <p className="text-gray-400 text-sm" data-id="element-8692" data-mp="5cocix6emtej">
                © {new Date().getFullYear()} ToxicDetector. Todos os direitos
                reservados.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>;
}